import { api } from '@/utils/api'
import alert from '../helpers/alert'
// import router from '../router'

const state = () => {
  return {
    btnSave: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnCancel: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnDraft: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnItemSave: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnReject: {
      disabled: false,
      loading: false,
      hide: true
    },
    btnDelete: {
      disabled: false,
      loading: false,
      hide: true
    },
    docStatusOption: [],
    tableTab: {
      label: null,
      value: null,
      url: null,
      currentUrl: null,
      page: 1
    },
    search: {
      field: null,
      type: 'like',
      value: null,
      companySelected: [],
      statusSelected: []
    },
    isClaim: false,
    isApprove: false,
    countMyDoc: 0,
    files: [],
    documentPath: null,
    documentPathText: null,
    memo: [],
    filterOption: [],
    approveOption: []
  }
}

const getters = {
  getFileAttach(state) {
    return state.files.map(item => {
      return {
        id: item.id,
        path_file: item.path_file,
        path_thumbnail: item.path_thumbnail,
        url_file: item.url_file,
        url_thumbnail: item.url_thumbnail
      }
    })
  }
}

const mutations = {
  initBtn(state) {
    state.btnSave = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnCancel = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnDraft = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnItemSave = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnReject = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.btnDelete = {
      disabled: false,
      loading: false,
      hide: true
    }
    state.isClaim = false
    state.isApprove = false
    // state.docStatusOption = []
    // state.filterOption = []
    state.countMyDoc = 0
    state.files = []
    state.documentPath = null
    state.documentPathText = null
  },
  setBtnActive(state, data) {
    state[data.type].loading = !state[data.type].loading
    state[data.type].disabled = !state[data.type].disabled
  },
  setBtnActiveFix(state, data) {
    state[data.type].loading = data.status
    state[data.type].disabled = data.status
  },
  setBtn(state, data) {
    state[data.type][data.value] = !state[data.type][data.value]
  },
  setFile(state, data) {
    state.files.push(data)
  },
  removeFile(state, id) {
    const newFile = state.files.filter(item => {
      return item.id !== id
    })
    state.files = newFile
  },
  setDocumentPath(state, data) {
    state.documentPath = data
  },
  setDocumentPathText(state, data) {
    state.documentPathText = data
  },
  setDocStatusOption(state, data) {
    state.docStatusOption = data
  },
  setFilterOption(state, data) {
    state.filterOption = data
  },
  setCountMyDoc(state, count) {
    state.countMyDoc = count
  },
  setTableTab(state, tab) {
    state.tableTab.label = tab.label
    state.tableTab.value = tab.value
    state.tableTab.url = tab.url
    state.tableTab.currentUrl = tab.url
  },
  setCompanyAndStatus(state, data) {
    state.search.companySelected = data.companySelected
    state.search.statusSelected = data.statusSelected
    state.search.field = data.field
    state.search.value = data.value
  },
  updateTableTab(state, tab) {
    state.tableTab.currentUrl = tab.currentUrl
    state.tableTab.page = tab.page
  },
  clearTableTab(state, data) {
    state.search.companySelected = []
    state.search.statusSelected = []
    state.search.field = data.field
    state.search.value = null

    state.tableTab.currentUrl = state.tableTab.url
    state.tableTab.page = 1
  },
  clearSelectedCompanyAndStatus(state) {
    state.search.companySelected = []
    state.search.statusSelected = []
  },
  setMemo(state, data) {
    state.memo = data
    // state.memo = data ? data.map(item => {
    //   return {
    //     id: item.id,
    //     title: item.title,
    //     doc_no: item.doc_no,
    //     doc_no_full: item.doc_no_full
    //   }
    // }) : []
  },
  setApproveOption(state, data) {
    state.approveOption = data
  },
  setIsClaim(state, data) {
    state.isClaim = data
  },
  setIsApprove(state, data) {
    state.isApprove = data
  }
}

const actions = {
  // async loadDocumentPath({ commit }, payload) {
  //   // console.log('load document path', payload)
  //   if (payload.specialPath === null) {
  //     await api
  //       .get(
  //         `/hr/employee/documentPath?doc_type=PV&comp_no=${payload.compNo}&employee_id=${payload.employeeId}`
  //       )
  //       .then(res => {
  //         if (res.code == 200) {
  //           commit('setDocumentPath', res.data.documentPath)
  //           commit('setDocumentPathText', res.data.documentPathText)
  //         }
  //       })
  //   } else {
  //     await api
  //       .get(
  //         `/hr/employee/documentPath?doc_type=PV&special_path=${payload.specialPath}&comp_no=${payload.compNo}&employee_id=${payload.employeeId}`
  //       )
  //       .then(res => {
  //         if (res.code == 200) {
  //           commit('setDocumentPath', res.data.documentPath)
  //           commit('setDocumentPathText', res.data.documentPathText)
  //         }
  //       })
  //   }
  // },
  async loadDocumentPath({ commit }, payload) {
    let urlApi = null
    const pettyCash = payload.cashSelected == 'p' ? '&petty_cash=true' : ''
    if (payload.specialPath === null) {
      urlApi = `/hr/employee/documentPath?doc_type=PV&comp_no=${payload.compNo}&employee_id=${payload.employeeId}${pettyCash}`
    } else {
      urlApi = `/hr/employee/documentPath?doc_type=PV&special_path=${payload.specialPath}&comp_no=${payload.compNo}&employee_id=${payload.employeeId}${pettyCash}`
    }

    await api.get(urlApi).then(res => {
      if (res.code == 200) {
        commit('setDocumentPath', res.data.documentPath)
        commit('setDocumentPathText', res.data.documentPathText)
      }
    })
  },
  async loadDocStatusOption({ commit, state, rootState }) {
    if (state.docStatusOption.length == 0) {
      await api
        .get(
          `/reimbursement/pv/getOptionDocMenu?showTabMonitor=${rootState.auth.info.showTabMonitor}&roleCode=${rootState.auth.info.roleCode}`
        )
        .then(res => {
          if (res.code == 200) {
            commit('setDocStatusOption', res.data)
            commit('setTableTab', res.data[0])
          }
        })
    }
  },
  async loadFilterOption({ commit, state }) {
    if (state.filterOption.length == 0) {
      await api.get('/reimbursement/pv/allOption').then(res => {
        commit('setFilterOption', res.data)
      })
    }
  },
  async loadCountMyDoc({ commit }, employeeId) {
    await api
      .get(`/reimbursement/pv/countDocWait/${employeeId}`)
      .then(async res => {
        if (res.code == 200) {
          commit('setCountMyDoc', res.data.doc_wait)
          commit(
            'global/setDocWaitType',
            { type: 'pv', value: res.data.doc_wait },
            { root: true }
          )
        }
      })
  },
  async loadMemo({ commit }, data) {
    await api
      .get(`/memo/memo/getMyDocForUse?group_month=true&back_month=${process.env.VUE_APP_API_MEMO_BACK_MONTH}`)
      .then(res => {
        if (res.code == 200) {
          commit('setMemo', res.data)
        }
      })
  },
  async loadApproveOption({ commit, state }, data) {
    await api
      .get(
        `/reimbursement/pv/getOptionApproveResult?employeeId=${data.employeeID}&docId=${data.docID}`
      )
      .then(res => {
        if (res.code == 200) {
          commit('setApproveOption', res.data)
        }
      })
  },
  async approveClaim({ commit }, data) {
    return await api.post('/reimbursement/pv/claim', data).then(res => {
      if (res.code == 200) {
        commit('setIsClaim', false)
        alert.success()
        return res.data.employee_id
      } else {
        alert.error(res.message)
        return false
      }
      // return { code:// res.code, message: res.message }
    })
  },
  async approvePV({ commit }, data) {
    return await api
      .post('/reimbursement/pv/approve', data)
      .then(res => {
        if (res.code == 200) {
          commit('setIsApprove', true)
          alert.success()
          return true
        } else {
          alert.error(res.message)
          return false
        }
      })
      .catch(e => {
        alert.error(e.message)
        return false
      })
  },
  setTableTab({ commit }, tab) {
    commit('setTableTab', tab)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
